export default __webpack_public_path__ + "static/media/loading.fe94d454.gif";